import {
  Button,
  Col,
  Form,
  Input,
  Row,
  notification,
  Checkbox,
  Drawer,
  Tabs,
  Pagination,
  Spin,
  Empty,
  message,
  Tag,
} from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleDoubleUp,
  faAngleRight,
  faAngleLeft,
} from "@fortawesome/free-solid-svg-icons";
import CarItem from "./CarItem";
import "moment/locale/vi"; // Import locale tiếng Việt
import React, { useEffect, useState, useRef } from "react";
import { createPortal } from "react-dom";
import $axios from "../../services/axios";
import BookingJSON from "../../data-test/booking.json";
import { CloseOutlined, TagOutlined } from "@ant-design/icons";
import InfoCar from "./InfoCar";
import _ from "lodash";
import dayjs from "dayjs";
import moment from "moment";

const { TabPane } = Tabs;
const ChooseCar = ({
  carSelected,
  open,
  setOpenChooseCar,
  setCarSelected,
  area,
  addPrice = 0,
  tripType,
  filterSearch,
}) => {
  const formRef = useRef(null);
  const [form] = Form.useForm();
  const invoice = Form.useWatch("invoice", form);
  const [step, setStep] = useState(1);
  // NOTE: 4 step : 1,2,3,4
  // step === 1 : Chọn xe chiều đi
  // step === 2 : Chọn danh sách xe
  // step === 3 : Chọn xe chiều về
  // step === 4 : Điền form đặt xe
  const [openCarInfo, setOpenCarInfo] = useState(false);
  const [activeTabCarInfo, setActiveTabCarInfo] = useState("1");
  const [voucherValue, setVoucherValue] = useState(0);
  const [voucherCode, setVoucherCode] = useState("");
  const [manualVoucherCode, setManualVoucherCode] = useState("");
  const [voucherTxt, setVoucherTxt] = useState("");
  const [bookingField, setBookingField] = useState("depart");
  const [loadingBooking, setLoadingBooking] = useState(false);
  const [searched, setSearched] = useState(false);
  const [loading, setLoading] = useState(true);
  const [bookingInfo, setBookingInfo] = useState({
    depart: null,
    return: null,
  });
  const [carDepart, setCarDepart] = useState(null);
  const [carReturn, setCarReturn] = useState(null);
  const [listTripReturn, setListTripReturn] = useState([]);
  const [totalTripReturn, setTotalTripReturn] = useState(0);
  const [infoTripList, setInfoTripList] = useState({
    depart: null,
    return: null,
  });
  const [title, setTitle] = useState(
    tripType === "roundTrip" ? "1. CHỌN SỐ KHÁCH CHIỀU ĐI" : "1. CHỌN SỐ KHÁCH"
  );
  const [filterReturn, setFilterReturn] = useState({
    ...filterSearch,
    addStart: filterSearch.addEnd,
    addEnd: filterSearch.addStart,
  });
  const [openVoucher, setOpenVoucher] = useState(false);
  const [vouchers, setVouchers] = useState([]);

  const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));

  useEffect(() => {
    if (carSelected && open) {
      setCarDepart(carSelected);
    }
  }, [carSelected, open]);

  useEffect(() => {
    if (step === 1) {
      setTitle(
        tripType === "roundTrip"
          ? "1. CHỌN SỐ KHÁCH CHIỀU ĐI"
          : "1. CHỌN SỐ KHÁCH"
      );
    } else if (step === 2) {
      setTitle("2. CHỌN XE CHIỀU VỀ");
    } else if (step === 3) {
      setTitle("3. CHỌN SỐ KHÁCH CHIỀU VỀ");
    } else {
      setTitle(`${tripType === "roundTrip" ? "4" : "2"}. THÔNG TIN KHÁCH HÀNG`);
    }
  }, [step, tripType]);

  useEffect(() => {
    if (step === 4) {
      getVouchers();
    } else {
      handleClearVoucher();
    }
  }, [step]);

  const getVouchers = async () => {
    setLoading(true);
    try {
      const quantity =
        tripType === "roundTrip"
          ? _.sum([
            bookingInfo?.depart?.seatChoosed?.length || 0,
            bookingInfo?.return?.seatChoosed?.length || 0,
          ])
          : bookingInfo?.depart?.seatChoosed?.length || 1;
      const total =
        tripType === "roundTrip"
          ? _.sum([
            bookingInfo?.depart?.totalPrice || 0,
            bookingInfo?.return?.totalPrice || 0,
          ])
          : bookingInfo?.depart?.totalPrice || 0;

      const res = await $axios.$post("/voucher/getVoucherByOrder", {
        Quantity: quantity,
        Total: total,
        FlightRouteType: null,
      });

      const now = moment();
      const validVouchers = (res?.data?.data || []).filter((voucher) => {
        const start = moment(voucher.startdate);
        const end = moment(voucher.enddate);
        return now.isBetween(start, end, null, "[]");
      });
      setVouchers(validVouchers);
    } catch (error) {
      setVouchers([]);
    } finally {
      setLoading(false);
    }
  };

  const handleClearVoucher = () => {
    setVoucherValue(0);
    setVoucherCode("");
    setManualVoucherCode("");
    setVoucherTxt("");
  };

  const applyVoucherPick = (voucher) => {
    if (!voucher) return;
    const currentTotal =
      tripType === "roundTrip"
        ? _.sum([
          bookingInfo?.depart?.totalPrice || 0,
          bookingInfo?.return?.totalPrice || 0,
        ])
        : bookingInfo?.depart?.totalPrice || 0;

    let amount = 0;
    if (typeof voucher.amount === "number" && voucher.amount > 0) {
      amount = voucher.amount;
    } else if (
      voucher.discounttype === "PERCENTAGE" ||
      voucher.discountType === "PERCENTAGE"
    ) {
      const discountVal =
        voucher.discountvalue || voucher.discountValue || 0;
      const amountDiscount = Math.ceil(
        currentTotal * (discountVal / 100)
      );
      const maxDiscount =
        voucher.maxdiscountvalue || voucher.maxDiscountValue;
      amount = maxDiscount
        ? Math.min(amountDiscount, maxDiscount)
        : amountDiscount;
    } else if (voucher.amountvoucher || voucher.amountVoucher) {
      amount = voucher.amountvoucher || voucher.amountVoucher;
    }

    if (amount > 0) {
      const vCode = voucher.code || voucher.VoucherCode || "";
      setVoucherValue(amount);
      setVoucherCode(vCode);
      setManualVoucherCode(vCode);
      setVoucherTxt(
        `<div class="text-[14px]">Áp dụng mã giảm giá thành công! <span class="text-green-600 font-bold text-[16px]">
  -${amount.toLocaleString("vi-VN")} đ</span></div>`
      );
      notification.success({
        message: "Thành công",
        description: `Áp dụng mã giảm giá ${vCode} thành công!`,
      });
      setOpenVoucher(false);
    } else {
      const errMsg =
        voucher?.message || "Mã giảm giá không hợp lệ hoặc không đủ điều kiện!";
      setVoucherTxt(`<div class="text-[14px] text-red-600">${errMsg}</div>`);
      notification.error({
        message: "Áp dụng thất bại",
        description: errMsg,
      });
      handleClearVoucher();
    }
  };

  const applyVoucher = async (e) => {
    const code = (typeof e === "string" ? e : manualVoucherCode || "").trim();
    if (!code) {
      setVoucherTxt(
        `<div class="text-[14px] text-red-600">Vui lòng nhập mã giảm giá!</div>`
      );
      return;
    }

    setLoading(true);
    const currentTotal =
      tripType === "roundTrip"
        ? _.sum([
          bookingInfo?.depart?.totalPrice || 0,
          bookingInfo?.return?.totalPrice || 0,
        ])
        : bookingInfo?.depart?.totalPrice || 0;

    const currentQuantity =
      tripType === "roundTrip"
        ? _.sum([
          bookingInfo?.depart?.seatChoosed?.length || 0,
          bookingInfo?.return?.seatChoosed?.length || 0,
        ])
        : bookingInfo?.depart?.seatChoosed?.length || 1;

    try {
      const payload = {
        Quantity: currentQuantity,
        Total: currentTotal,
        VoucherCode: code,
        FlightRouteType: null,
      };

      const res = await $axios.$post("/voucher/getVoucher", payload);
      const voucherData = res?.data?.data || res?.data;
      if ((res?.data?.statuscode === 200 || res?.status === 200) && voucherData) {
        applyVoucherPick(voucherData);
      } else {
        const errMsg =
          voucherData?.message ||
          res?.data?.message ||
          "Mã giảm giá không hợp lệ! Vui lòng thử lại";
        setVoucherTxt(`<div class="text-[14px] text-red-600">${errMsg}</div>`);
        notification.error({
          message: "Áp dụng thất bại",
          description: errMsg,
        });
        handleClearVoucher();
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.message ||
        error?.response?.data?.err ||
        "Mã giảm giá không hợp lệ! Vui lòng thử lại";
      setVoucherTxt(`<div class="text-[14px] text-red-600">${errMsg}</div>`);
      notification.error({
        message: "Áp dụng thất bại",
        description: errMsg,
      });
      handleClearVoucher();
    } finally {
      setLoading(false);
    }
  };

  const handleFindRouteReturn = async (filter) => {
    setLoading(true);
    setSearched(true);
    try {
      const body = {
        From: filter.addStart,
        To: filter.addEnd,
        Date: dayjs(filter.returnDate).format("YYYY-MM-DD"),
        OnlineTicket: filter.onlineTicket,
        Page: filter.currentPage,
        PageSize: 20,
      };

      if (!_.isNil(filter.isPromotion)) {
        body.IsPromotion = filter.isPromotion;
      }
      if (!_.isNil(filter.fareMin)) {
        body.FareMin = filter.fareMin;
      }
      if (!_.isNil(filter.fareMax)) {
        body.FareMax = filter.fareMax;
      }
      if (!_.isNil(filter.availableSeatMin)) {
        body.AvailableSeatMin = filter.availableSeatMin;
      }
      if (!_.isNil(filter.availableSeatMax)) {
        body.AvailableSeatMax = filter.availableSeatMax;
      }
      if (!_.isNil(filter.ratingMin)) {
        body.RatingMin = filter.ratingMin;
      }
      if (!_.isNil(filter.ratingMax)) {
        body.RatingMax = filter.ratingMax;
      }
      if (!_.isNil(filter.timeMin)) {
        body.TimeMin = filter.timeMin;
      }
      if (!_.isNil(filter.timeMax)) {
        body.TimeMax = filter.timeMax;
      }
      if (!_.isNil(filter.limousine)) {
        body.Limousine = filter.limousine;
      }
      if (!_.isNil(filter.companies) && filter.companies.length > 0) {
        body.Companies = filter.companies;
      }

      const res = await $axios.$post("/cheapbus/routes", body);
      setListTripReturn(res.data.data.data);
      setTotalTripReturn(res.data.data.total);
    } catch (error) {
      notification.error({
        status: "error",
        message: "Thất bại!",
        description: "Đã có lỗi xảy ra!",
      });
    } finally {
      setLoading(false);
    }
  };

  const convertBodyBooking = (values) => {
    let ListBooking = [];
    console.log(bookingInfo,'bookingInfo');
    
    _.forEach(bookingInfo, (booking, key) => {
      if (!_.isNil(booking)) {
        const body = {
          TripCode:
            key === "depart"
              ? carDepart?.route?.schedules[0]?.trip_code
              : carReturn?.route?.schedules[0]?.trip_code,
          TripDate: key === "depart" ? infoTripList.depart?.departure_time : infoTripList.return?.departure_time,
          Seats: booking.seatChoosed.map((s) => s.full_code).join(","),
          CustomerName: values.customer_name,
          CustomerPhone: values.customer_phone,
          CustomerEmail: values.customer_email,
          CountryCode: "vn",
          HaveEating: 0, // ăn hoặc không
          Note: values.customer_note,
          // AreaId: Number(booking.addChoosed.start.areaDetail.id),
          // CustomerIdNumber:
          //   infoTripList[key]?.company_id === 11071
          //     ? values.customer_id_number
          //     : "",
        };
        if (_.isNil(booking.addChoosed.start.is_transfer)) {
          // bình thường
          body.PickupId = booking.addChoosed.start.id;
          body.Pickup =
            booking.addChoosed?.start?.transfer_point ||
            booking.addChoosed.start.name;
        } else {
          body.TransferId = booking.addChoosed.start.id;
          body.Transfer =
            booking.addChoosed?.start?.transfer_point ||
            booking.addChoosed.start.name;
        }
        if (_.isNil(booking.addChoosed.end.is_transfer)) {
          // bình thường
          body.DropOffPointId = booking.addChoosed.end.id;
          body.DropOffInfo =
            booking.addChoosed?.end?.transfer_point ||
            booking.addChoosed?.end.name;
        } else {
          body.ArriveTransferId = booking.addChoosed.end.id;
          body.DropOffTransferInfo =
            booking.addChoosed?.end?.transfer_point ||
            booking.addChoosed?.end.name;
        }
        ListBooking.push(body);
      }
    });
    console.log(bookingInfo, 'bookingInfo');

    const originalTotal = _.sum([
      bookingInfo?.depart?.totalPrice || 0,
      bookingInfo?.return?.totalPrice || 0,
    ]);
    const finalAmount = Math.max(0, originalTotal - (voucherValue || 0));
    const totalQuantity = _.sum([
      bookingInfo?.depart?.seatChoosed?.length || 0,
      bookingInfo?.return?.seatChoosed?.length || 0,
    ]);

    let body = {
      Quantity: totalQuantity,
      Amount: finalAmount,
      VoucherCode: voucherCode || "",
      CustomerEmail: values.customer_email,
      CustomerName: values.customer_name,
      CustomerPhone: values.customer_phone,
      InfoOrder: "",
      ListBooking: ListBooking,
    };
    if (invoice) {
      body.VatMst = values.VatMst || "";
      body.VatEmail = values.customer_email || "";
      body.VatFullName = values.VatFullName || "";
    }
    return body;
  };


  const handleBooking = async (values) => {
    try {
      setLoadingBooking(true);
      const bodyBooking = convertBodyBooking(values);
      bodyBooking.InfoOrder = JSON.stringify({
        Service: "bus",
        Sponsor: "IPASS",
        Amount: bodyBooking.Amount,
        Quantity: bodyBooking.Quantity,
        DepartureInfo: {
          Pickup: bodyBooking.ListBooking[0].Pickup,
          DropOff: bodyBooking.ListBooking[0].DropOffInfo,
          Seats: bodyBooking?.ListBooking[0]?.Seats,
          TripDate: bodyBooking.ListBooking[0].TripDate,
          companyName: bookingInfo.depart.companyName
        },
        ArriveInfo: bodyBooking?.ListBooking.length > 1 ? {
          Pickup: bodyBooking?.ListBooking[1]?.Pickup,
          DropOff: bodyBooking?.ListBooking[1]?.DropOffInfo,
          Seats: bodyBooking?.ListBooking[1]?.Seats,
          TripDate: bodyBooking?.ListBooking[1]?.TripDate,
          companyName: bookingInfo?.return?.companyName
        } : {},
        VoucherCode: voucherCode || "",
        VoucherValue: voucherValue || 0,
      });
      const resPayment = await $axios.post(
        "/cheapbus/paymentRequired",
        bodyBooking
      );

      if (resPayment.data.data.ordercode) {
        // Send orderCode for IOS
        if (
          window.webkit &&
          window.webkit.messageHandlers &&
          window.webkit.messageHandlers.NativeJavascriptInterface
        ) {
          // Chuyển đổi dữ liệu thành chuỗi JSON và gửi qua Swift
          window.webkit.messageHandlers.NativeJavascriptInterface.postMessage({
            orderCode: resPayment.data.data.ordercode,
          });
        } else {
          console.error(
            "NativeJavascriptInterface không tồn tại hoặc không được hỗ trợ."
          );
        }
        // Send orderCode for Android
        if (window.webkit !== undefined) {
          if (window.webkit.messageHandlers.appInterface !== undefined) {
            window.webkit.messageHandlers.appInterface.postMessage(
              JSON.stringify({
                orderCode: resPayment.data.data.ordercode,
              })
            );
          }
        }
        if (window.appInterface !== undefined) {
          window.appInterface.postMessage(
            JSON.stringify({
              orderCode: resPayment.data.data.ordercode,
            })
          );
        }
        // window.location.href = resPayment.data.data.paymentUrl;
      } else {
        notification.error({
          status: "error",
          message: "Thất bại",
          description: "Đã có lỗi xảy ra! Vui lòng đặt chuyến khác",
        });
      }
    } catch (error) {
      console.log(error, "error");
      notification.error({
        status: "error",
        message: "Thất bại",
        description: error?.response?.data?.message || "Đã có lỗi xảy ra!",
      });
    } finally {
      setLoadingBooking(false);
    }
  };

  const handleValidateChooseSeat = () => {
    if (
      (bookingInfo[bookingField].addChoosed.start.unfixed_point === 1 &&
        !bookingInfo[bookingField].addChoosed.start.transfer_point) ||
      (bookingInfo[bookingField].addChoosed.end.unfixed_point === 1 &&
        !bookingInfo[bookingField].addChoosed.end.transfer_point)
    ) {
      notification.error({
        description: "Bạn chưa nhập điểm đón/trung chuyển đón",
      });
      return;
    }

    if (step === 1 && tripType === "roundTrip") {
      setStep(2);
      handleFindRouteReturn(filterReturn);
    } else {
      setStep(4);
    }
  };

  const handleOkNotValidTrip = () => {
    setOpenChooseCar(false);
    setCarSelected(null);
  };

  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  return (
    <>
      {open && createPortal(
        <div
          className="fixed inset-0 z-[1000] flex flex-col bg-white"
          style={{
            transform: open ? "translateY(0)" : "translateY(100%)",
            transition: "transform 0.3s cubic-bezier(0.23, 1, 0.32, 1)",
            pointerEvents: open ? "auto" : "none",
            height: "100dvh",
          }}
        >
          {/* Header (Ordered 1) */}
          <div className="flex-none bg-[#0064d2] text-white flex justify-between items-center px-4 py-3 sm:px-6 sm:py-4 shadow-sm z-10" style={{ order: 1 }}>
            <div className="text-[16px] font-bold m-0 uppercase">{title}</div>
            <button
              type="button"
              className="w-8 h-8 bg-transparent hover:bg-white/20 text-white flex items-center justify-center rounded-full transition-colors border-none cursor-pointer outline-none"
              onClick={() => {
                setOpenChooseCar(false);
                setCarSelected(null);
              }}
            >
              <CloseOutlined style={{ fontSize: '18px' }} />
            </button>
          </div>

          {/* Footer (Ordered 3) */}
          <div className="flex-none bg-white border-t border-gray-200 p-4 sm:p-6 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.05)] z-10" style={{ order: 3 }}>
            <>
            {(step === 1 || step === 3) && (
              <>
                {bookingInfo[bookingField]?.addChoosed?.start &&
                  bookingInfo[bookingField]?.addChoosed?.end &&
                  bookingInfo[bookingField]?.seatChoosed?.length > 0 ? (
                  <div className="flex justify-between">
                    <div className="flex flex-col gap-2">
                      <div>
                        {bookingInfo[bookingField].seatChoosed.length} Khách{" "}
                        {!_.get(
                          step === 1 ? carDepart : carReturn,
                          "route.schedules[0].unchoosable",
                          0
                        ) &&
                          ":" +
                          bookingInfo[bookingField].seatChoosed
                            .map((s) => s.seat_code)
                            .join(",")}
                      </div>
                      <div>
                        Tổng tiền:{" "}
                        <span className="text-primary text-[20px] font-semibold">
                          {_.sum([
                            bookingInfo[bookingField].totalNetPrice,
                            bookingInfo[bookingField].totalSurcharge,
                          ]).toLocaleString("vi-VN")}{" "}
                          đ
                        </span>
                      </div>
                    </div>
                    <Button
                      className="w-[150px] h-[50px]"
                      type="primary"
                      onClick={() => handleValidateChooseSeat()}
                    >
                      <span className="text-[16px]">Tiếp tục</span>{" "}
                      <FontAwesomeIcon icon={faAngleRight} color="white" />
                    </Button>
                  </div>
                ) : (
                  <div className="flex flex-col">
                    <div className="flex items-center justify-center w-full mb-1">
                      <FontAwesomeIcon
                        icon={faAngleDoubleUp}
                        onClick={() => setOpenCarInfo(true)}
                        className="w-full h-5 text-primary cursor-pointer hover:opacity-80 transition-opacity"
                      />
                    </div>
                    <Tabs
                      className="w-full tabs-no-bottom"
                      onChange={(e) => {
                        setOpenCarInfo(true);
                        setActiveTabCarInfo(e);
                      }}
                      size="small"
                      activeKey={activeTabCarInfo}
                    >
                      <TabPane tab="Hình ảnh" key="1" className="px-0" />
                      <TabPane tab="Phí huỷ" key="2" className="px-0" />
                      <TabPane tab="Đánh giá" key="3" className="px-0" />
                      <TabPane tab="Chính sách" key="4" className="px-0" />
                    </Tabs>
                  </div>
                )}
              </>
            )}
            {step === 4 && (
              <div className="flex justify-between gap-5">
                <Button
                  className="w-full h-[50px] bg-primary  text-white"
                  loading={loadingBooking}
                  onClick={() => {
                    formRef.current.submit();
                  }}
                >
                  <span className="text-[16px]">Thanh toán</span>{" "}
                  <FontAwesomeIcon icon={faAngleRight} color="white" />
                </Button>
              </div>
            )}
          </>
          </div>
          {/* Body (Ordered 2) */}
          <div className="flex-1 overflow-y-auto bg-[#f0f2f5]" style={{ order: 2, WebkitOverflowScrolling: "touch", overscrollBehavior: "none" }}>
            <div className="bg-white min-h-full p-6">
              <Spin tip="Tải dữ liệu" size="large" spinning={loading}>
          {step > 1 && (
            <div className="w-[67px] ml-0 mb-4">
              <Button
                className="text-[14px] text-primary"
                icon={
                  <FontAwesomeIcon
                    icon={faAngleLeft}
                    className="text-primary"
                  />
                }
                onClick={() => {
                  setStep(tripType === "roundTrip" ? step - 1 : 1);
                }}
              >
                Quay lại
              </Button>
            </div>
          )}
          {(step === 1 || step === 3) && (
            <InfoCar
              carSelected={step === 1 ? carDepart : carReturn}
              addPrice={addPrice}
              bookingField={bookingField}
              setBookingInfo={setBookingInfo}
              bookingInfo={bookingInfo}
              handleOkNotValidTrip={handleOkNotValidTrip}
              openCarInfo={openCarInfo}
              setOpenCarInfo={setOpenCarInfo}
              setInfoTripList={setInfoTripList}
              infoTripList={infoTripList}
              setLoading={setLoading}
              activeTabCarInfo={activeTabCarInfo}
              setActiveTabCarInfo={setActiveTabCarInfo}
              loading={loading}
            />
          )}
          {step === 2 && (
            <>
              {listTripReturn && listTripReturn.length > 0 ? (
                <div className="flex flex-col">
                  <div className="mt-4 w-full">
                    {listTripReturn.map((item, index) => (
                      <CarItem
                        key={index}
                        setOpenChooseCar={setOpenChooseCar}
                        data={item}
                        setCarSelected={(e) => {
                          setCarReturn(e);
                          setStep(3);
                          setBookingField("return");
                        }}
                        addPrice={addPrice}
                        area={area}
                      />
                    ))}
                  </div>
                  <Pagination
                    current={filterReturn.currentPage}
                    className="my-4 w-full justify-center flex"
                    total={totalTripReturn}
                    onChange={(page) => {
                      const _filter = { ...filterReturn, currentPage: page };
                      setFilterReturn(_filter);
                      handleFindRouteReturn(_filter);
                    }}
                    pageSize={20}
                    showSizeChanger={false}
                    showQuickJumper={false}
                  />
                </div>
              ) : (
                <>
                  {!loading && searched && (
                    <div className="flex flex-col w-full items-center mt-[48px]">
                      <div className="text-[24px] text-primary font-bold text-center mb-3">
                        Không tìm thấy chuyến trên Ipass
                      </div>
                      <div className="mb-4 text-center text-primary">
                        Hiện tại <span className="font-bold">Ipass</span> chưa
                        cập nhật đơn hàng của tuyến{" "}
                        <span className="font-bold">
                          {area?.to?.name} - {area?.from?.name} ngày{" "}
                          {dayjs(filterReturn.returnDate).format("DD-MM-YYYY")}
                        </span>
                      </div>
                      <div className="mb-4 text-center text-primary">
                        Xin quý khách vui lòng tìm chuyến với ngày khởi hành
                        khác hoặc thay đổi tuyến đường tìm kiếm.
                      </div>
                      <Empty description={""} />
                    </div>
                  )}
                </>
              )}
            </>
          )}
          {step === 4 && (
            <div>
              <Form
                layout="vertical"
                form={form}
                ref={formRef}
                onFinish={handleBooking}
                onFinishFailed={(values) => {
                  notification.error({
                    message: "Thông báo",
                    description: "Vui lòng nhập đầy đủ thông tin",
                  });
                }}
                autoComplete="off"
                className="form"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                initialValues={{
                  customer_name: userInfo?.name || "",
                  customer_phone: userInfo?.phone || "",
                  customer_email: userInfo?.email || "",
                }}
              >
                <Row gutter={12}>
                  <Col span={12}>
                    <Form.Item
                      name="customer_name"
                      className="mb-4"
                      rules={[
                        {
                          required: true,
                          message: "Họ tên không được để trống",
                        },
                      ]}
                    >
                      <Input placeholder="Họ Tên" className="h-12" />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="customer_phone"
                      rules={[
                        {
                          required: true,
                          message: "Số điện thoại không được để trống",
                        },
                        {
                          pattern: /^(03|05|07|08|09)\d{8}$|^\+84\d{9}$/,
                          message: "Số điện thoại không hợp lệ",
                        },
                      ]}
                      className="mb-4"
                    >
                      <Input placeholder="SĐT: 0912345678" className="h-12" />
                    </Form.Item>
                  </Col>
                </Row>
                <Form.Item
                  name="customer_email"
                  className="mb-4"
                  rules={[
                    {
                      required: true,
                      message: "Email không được để trống",
                    },
                    {
                      type: "email",
                      message: "Vui lòng nhập email đúng định dạng",
                    },
                  ]}
                >
                  <Input placeholder="Email" className="h-12" />
                </Form.Item>
                {(infoTripList?.depart?.company_id === 11071 ||
                  infoTripList?.return?.company_id === 11071) && (
                    <Form.Item name="customer_id_number" className="mb-4">
                      <Input placeholder="Chứng minh nhân dân" className="h-12" />
                    </Form.Item>
                  )}
                {/* <Form.Item name="customer_address" className="mb-4">
              <Input placeholder="Nơi ở hiện nay" className="h-12" />
            </Form.Item> */}
                <Form.Item name="customer_note" className="mb-4">
                  <Input.TextArea
                    placeholder="Các yêu cầu đặc biệt không thể được đảm bảo - nhưng nhà xe sẽ cố gắng hết sức để đáp ứng nhu cầu của bạn."
                    rows={3}
                  />
                </Form.Item>
                <Form.Item
                  label=""
                  name="invoice"
                  className="mb-3"
                  valuePropName="checked"
                >
                  <Checkbox>Xuất hoá đơn</Checkbox>
                </Form.Item>
                {invoice && (
                  <>
                    <Row gutter={8}>
                      <Col span={12}>
                        <Form.Item
                          name="VatMst"
                          className="mb-3"
                          rules={[
                            {
                              required: true,
                              message: "Mã số thuế không được để trống",
                            },
                          ]}
                        >
                          <Input className="h-12" placeholder="Mã số thuế..." />
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item
                          name="VatFullName"
                          className="mb-3"
                          rules={[
                            {
                              required: true,
                              message: "Người nhận hoá đơn không được để trống",
                            },
                          ]}
                        >
                          <Input
                            className="h-12"
                            placeholder="Nhập người nhận hoá đơn..."
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </>
                )}
                <div
                  style={{
                    boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
                  }}
                  className=" bg-white p-4 text-[#0D1634] rounded-[20px] mb-3"
                >
                  <div className="flex justify-between items-center">
                    <span className="font-semibold">Mã khuyến mãi</span>
                    <div className="flex items-center gap-1">
                      <Tag
                        onClick={() => setOpenVoucher(true)}
                        color={
                          voucherCode === "" && voucherValue === 0
                            ? "default"
                            : "success"
                        }
                        icon={<TagOutlined />}
                        className="cursor-pointer"
                      >
                        {voucherCode === "" && voucherValue === 0
                          ? "Chọn mã giảm giá"
                          : voucherCode}
                      </Tag>
                      {voucherCode !== "" && voucherValue > 0 && (
                        <CloseOutlined
                          style={{ fontSize: 16, color: "red", cursor: "pointer" }}
                          onClick={handleClearVoucher}
                        />
                      )}
                    </div>
                  </div>
                  {voucherTxt && (
                    <div
                      className="mt-3"
                      dangerouslySetInnerHTML={{ __html: voucherTxt }}
                    />
                  )}
                  <Drawer
                    title={
                      <div className="flex flex-col gap-4">
                        <div className="flex justify-between items-center">
                          <span className="uppercase font-bold text-[18px]">
                            Mã giảm giá của tôi
                          </span>
                          <CloseOutlined
                            onClick={() => setOpenVoucher(false)}
                            style={{ fontSize: 18, cursor: "pointer" }}
                          />
                        </div>
                        <div>
                          <Input.Search
                            placeholder="Nhập mã giảm giá khác..."
                            enterButton={
                              <Button
                                type="primary"
                                className="bg-primary text-white font-medium"
                              >
                                Áp dụng
                              </Button>
                            }
                            allowClear
                            value={manualVoucherCode}
                            onChange={(e) =>
                              setManualVoucherCode(e.target.value.toUpperCase())
                            }
                            onSearch={(val) => applyVoucher(val)}
                          />
                          {voucherTxt && (
                            <div
                              className="mt-2 text-sm"
                              dangerouslySetInnerHTML={{ __html: voucherTxt }}
                            />
                          )}
                        </div>
                      </div>
                    }
                    placement={"bottom"}
                    closable={false}
                    onClose={() => setOpenVoucher(false)}
                    open={openVoucher}
                    height={"100%"}
                    bodyStyle={{
                      background: "#f3f6f6",
                    }}
                  >
                    <div>
                      {!vouchers || vouchers.length === 0 ? (
                        <Empty description="Không có mã giảm giá khả dụng" />
                      ) : (
                        vouchers.map((voucher) => (
                          <div
                            key={voucher.id || voucher.code}
                            style={{
                              boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
                            }}
                            className="rounded-[14px] bg-white p-3 mb-4"
                          >
                            <div className="flex gap-4 w-full">
                              <div className="w-1/5 flex items-center justify-center">
                                <img
                                  src="/images/logo-vexere.png"
                                  className="w-[80px]"
                                  alt=""
                                />
                              </div>
                              <div className="border-lime-300 border-1 flex flex-col gap-1 flex-1">
                                <div className="font-semibold text-[16px] text-primary">
                                  Mã {voucher.code}
                                </div>
                                <div className="text-red-600 text-[14px] font-bold">
                                  {voucher.title}
                                </div>
                                <div className="text-[14px]">
                                  Áp dụng từ{" "}
                                  {dayjs(voucher.startdate).format(
                                    "HH:mm DD/MM/YYYY"
                                  )}{" "}
                                  đến{" "}
                                  {dayjs(voucher.enddate).format(
                                    "HH:mm DD/MM/YYYY"
                                  )}
                                </div>
                                <div
                                  onClick={() => applyVoucherPick(voucher)}
                                  className="text-blue-700 font-medium text-[14px] ml-auto cursor-pointer"
                                >
                                  Áp dụng
                                </div>
                              </div>
                            </div>
                          </div>
                        ))
                      )}
                    </div>
                  </Drawer>
                </div>
              </Form>
              <div className="p-2 bg-[#e7ffe5] text-[#7bc27b] rounded my-4">
                Vui lòng cung cấp email và số điện thoại Việt Nam của người đi.
              </div>

              {(tripType === "roundTrip"
                ? ["depart", "return"]
                : ["depart"]
              ).map((type) => (
                <div key={type}>
                  {tripType === "roundTrip" && (
                    <div className="text-[16px] font-bold text-left mt-4 text-primary">
                      {type === "depart" ? "Chiều đi" : "Chiều về"}
                    </div>
                  )}

                  <div className="flex flex-col items-center gap-2 my-5">
                    <div className="font-semibold">
                      {infoTripList[type]?.company_name}
                    </div>
                    <div className="text-[12px] italic">
                      {infoTripList[type]?.departure_time.split(" ")[0]}{" "}
                      {infoTripList[type]?.departure_time.split(" ")[1]} •{" "}
                      {type === "depart" ? (
                        <span>
                          {" "}
                          {area?.from?.name} - {area?.to?.name}
                        </span>
                      ) : (
                        <span>
                          {" "}
                          {area?.to?.name} - {area?.from?.name}
                        </span>
                      )}
                    </div>
                  </div>

                  {!_.get(
                    type === "depart" ? carDepart : carReturn,
                    "route.schedules[0].unchoosable",
                    0
                  ) && (
                      <Row className="mb-2">
                        <Col span={8}>
                          <div>Khách: </div>
                        </Col>
                        <Col span={16}>
                          <div className="font-semibold text-right">
                            {bookingInfo[type].seatChoosed
                              .map((s) => s.seat_code)
                              .join(",")}
                          </div>
                        </Col>
                      </Row>
                    )}

                  {infoTripList[type].company_id === 11071 && (
                    <Row className="mb-[32px]">
                      <Col span={8}>
                        <div>Phí dịch vụ: </div>
                      </Col>
                      <Col span={16}>
                        <div className="text-right font-semibold text-[20px] text-primary">
                          {" "}
                          {infoTripList[type]?.service_fee.toLocaleString(
                            "vi-VN"
                          )}{" "}
                          đ
                        </div>
                      </Col>
                    </Row>
                  )}
                  {voucherValue > 0 && tripType !== "roundTrip" && (
                    <Row className="mb-2">
                      <Col span={8}>
                        <div className="text-gray-600">Giảm giá: </div>
                      </Col>
                      <Col span={16}>
                        <div className="text-right font-semibold text-[16px] text-green-600">
                          -{voucherValue.toLocaleString("vi-VN")} đ
                        </div>
                      </Col>
                    </Row>
                  )}
                  <Row className="mb-[32px]">
                    <Col span={8}>
                      <div>Tổng tiền: </div>
                    </Col>
                    <Col span={16}>
                      <div className="text-right font-semibold text-[20px] text-primary">
                        {" "}
                        {Math.max(
                          0,
                          tripType === "roundTrip"
                            ? bookingInfo[type].totalPrice
                            : bookingInfo[type].totalPrice - voucherValue
                        ).toLocaleString("vi-VN")}{" "}
                        đ
                      </div>
                    </Col>
                  </Row>
                  <Row className="mb-2">
                    <Col span={8}>
                      <div>Điểm đi: </div>
                    </Col>
                    <Col span={16}>
                      <div className="flex flex-col">
                        <div className="text-[13px] text-right font-semibold">
                          {bookingInfo[type].addChoosed.start.name}{" "}
                        </div>
                        <div className="text-[13px] text-right italic">
                          {bookingInfo[type].addChoosed.start?.transfer_point
                            ? [
                              bookingInfo[type].addChoosed.start
                                ?.transfer_point || "",
                              bookingInfo[type].addChoosed.start.address,
                            ].join(", ")
                            : bookingInfo[type].addChoosed.start.address}
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <Row className="mb-2">
                    <Col span={8}>
                      <div>Điểm đến: </div>
                    </Col>
                    <Col span={16}>
                      <div className="flex flex-col">
                        <div className="text-[13px] text-right font-semibold">
                          {bookingInfo[type].addChoosed.end.name}{" "}
                        </div>
                        <div className="text-[13px] text-right italic">
                          {bookingInfo[type].addChoosed.end?.transfer_point
                            ? [
                              bookingInfo[type].addChoosed.end
                                ?.transfer_point || "",
                              bookingInfo[type].addChoosed.end.address,
                            ].join(", ")
                            : bookingInfo[type].addChoosed.end.address}
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              ))}

              {tripType === "roundTrip" && (
                <div className="mt-[24px]">
                  {voucherValue > 0 && (
                    <div className="flex justify-between items-center mb-2">
                      <span className="text-[16px] text-gray-600">Giảm giá voucher:</span>
                      <span className="text-green-600 text-[16px] font-semibold">
                        -{voucherValue.toLocaleString("vi-VN")} đ
                      </span>
                    </div>
                  )}
                  <div className="flex justify-between items-center">
                    <span className="text-[18px] font-bold">Tổng Tiền</span>
                    <span className="text-red-700 text-[22px] font-bold">
                      {Math.max(
                        0,
                        _.sum([
                          bookingInfo?.depart?.totalPrice || 0,
                          bookingInfo?.return?.totalPrice || 0,
                        ]) - (voucherValue || 0)
                      ).toLocaleString("vi-VN")}{" "}
                      đ
                    </span>
                  </div>
                </div>
              )}
            </div>
          )}
              </Spin>
            </div>
          </div>
        </div>,
        document.body
      )}
    </>
  );
};

export default ChooseCar;
